const chatAppUrl = window.location.origin.includes("localhost") ? "http://localhost:5001" : "https://www.lovespreadsheets.com";
// const chatAppUrl = "https://wwwchat.apispreadsheets.com";

export default chatAppUrl;